/** @format */

import {toStr} from 'helpers/stringHelpers';

import {AiReportGoal} from 'pages/Home/AiReports/components/FullReport/types';

import {GoalType, CampaignType, FormState, GoalOptionsInterface} from '../../types';

export const getInitialFormState = (): FormState => ({
  campaigns: [],
  startDate: null,
  endDate: null,
  goals: [],
  kpi: '',
  kpiAmount: '',
  attributionModel: 'LASTSIGN',
  budget: '',
});

export const isFormValid = (state: FormState): boolean => {
  return (
    state.campaigns.length > 0 &&
    state.goals.length > 0 &&
    state.kpi !== '' &&
    state.kpiAmount !== '' &&
    !!state.startDate &&
    !!state.endDate
  );
};

export const validateBudgetInput = (value: string): boolean => {
  return /^\d*\.?\d*$/.test(value);
};

export const transformGoalsToOptions = (goals: GoalType) => {
  if (!goals) return [];

  return goals.map(goal => ({
    id: toStr(goal.id),
    name: goal.name,
    counterId: toStr(goal.counterId),
    counterName: goal.counterName,
  }));
};

export const transformCampaignsToOptions = (campaigns: CampaignType) => {
  if (!campaigns) return [];
  return campaigns.map(campaign => ({
    id: campaign.campaignId,
    campaignId: campaign.campaignId,
    campaignName: campaign.campaignName,
    accountName: campaign.accountName,
  }));
};

export const getKpiSymbol = (kpiType: string): string => {
  switch (kpiType) {
    case 'DRR':
      return '%';
    case 'CPL':
      return '₽';
    default:
      return '₽';
  }
};

export interface ResolveGoalsResult {
  goals: AiReportGoal[];
  missingGoalIds: string[];
}

/**
 * Резолвит ID целей в полные объекты AiReportGoal
 * @param goalIds - массив ID целей из формы
 * @param goalOptions - доступные опции целей
 * @returns объект с разрешёнными целями и списком ненайденных ID
 */
export const resolveGoalsWithDetails = (
  goalIds: string[],
  goalOptions: GoalOptionsInterface[],
): ResolveGoalsResult => {
  const missingGoalIds: string[] = [];
  const goals: AiReportGoal[] = [];

  for (const goalId of goalIds) {
    const goal = goalOptions.find(opt => opt.id === goalId);
    if (!goal) {
      missingGoalIds.push(String(goalId));
      continue;
    }

    goals.push({
      id: Number(goalId),
      name: goal.name,
      counterId: Number(goal.counterId),
      counterName: goal.counterName,
    });
  }

  return {goals, missingGoalIds};
};
